import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";

import { comparator } from "./comparator";

/*------------------------------------*\
  #COMPARATORSELECTION
\*------------------------------------*/
class ComparatorSelection {
  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT CLICK
    document.addEventListener('click', this.clickHandler);

    this.setActiveElements();

    if(debug.DEBUG) console.log('modules/comparator-selection.js');
  }
  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="comparator-selection"]')) {
      this.selection(event.target);
    }
  }
  /**
   * SELECTION
   */
  selection = (element) => {
    const id = element.getAttribute('data-product-id');
    const name = element.getAttribute('data-product-name');
    const cat = element.getAttribute('data-product-cat');
    const added = comparator.selection(id, name, cat);
    this.setActiveElement(element, added);
  }
  /**
   * SETACTIVEELEMENT
   * @param {HTMLElement} element 
   * @param {boolean} state 
   * @returns 
   */
  setActiveElement = (element, state) => {
    element.classList.toggle('c-button--theme', state);
  }
  /**
   * SETACTIVEELEMENTS
   */
  setActiveElements = () => {
    const ids = comparator.cookieGetIds();
    if (!ids) return false;
    
    ids.forEach((id) => {
      const element = document.querySelector(`[data-js-component="comparator-selection"][data-product-id="${id}"]`);
      if (element) {
        this.setActiveElement(element, true);
      }
    });
  }
}
export const comparatorSelection = new ComparatorSelection('[data-js-component="comparator-selection"]'); 